import { dataHooks } from '../../../libs/dataHooks';

export const sortDataHooks = dataHooks<{
  dropdownToggle: {};
  dropdownToggleLabel: {};
  dropdown: { isOpen: boolean };
  dropdownOption: { slug: 'recommended' | string };
}>('sort');
